import React from 'react';
import { Component } from 'react';

export class SunCloud extends Component {
render(){
  return (
    <div className="Icon">
      <svg version="1.1" id="mostly_x5F_clear_x5F_day" xmlns="http://www.w3.org/2000/svg" 
                x="0px" y="0px" viewBox="0 0 24 24" enableBackground="new 0 0 24 24">
            <g>
                <rect fill="none" width="24" height="24"/>
                <circle fillRule="evenodd" clipRule="evenodd" fill="#FFD02F" cx="16" cy="8" r="6"/>
                <g>
                    <path fillRule="evenodd" clipRule="evenodd" fill="#FFFFFF" d="M5.25,20.5005c-1.5166,0-2.75-1.2334-2.75-2.75
                        c0-1.1265,0.6777-2.127,1.7266-2.5483l0.3506-0.1406l-0.04-0.3755C4.5137,14.4609,4.5,14.2329,4.5,14.0005
                        c0-3.584,2.916-6.5,6.5-6.5c2.9912,0,5.583,2.0288,6.3018,4.9331l0.0908,0.3677l0.3789,0.0117
                        c2.0908,0.0664,3.7285,1.7515,3.7285,3.8374c0,2.123-1.7275,3.8501-3.8506,3.8501H5.25z"/>
                    <path fill="#1D1D33" d="M10.9998,8.0003c2.7609,0,5.1527,1.8724,5.8163,4.5533l0.182,0.7352l0.757,0.024
                        c1.8195,0.0576,3.2447,1.5236,3.2447,3.3375c0,1.8472-1.5028,3.35-3.35,3.35h-12.4c-1.2407,0-2.25-1.0093-2.25-2.25
                        c0-0.921,0.5547-1.7391,1.413-2.0842l0.6991-0.2811l-0.0774-0.7495c-0.0234-0.2262-0.0347-0.434-0.0347-0.6353
                        C4.9998,10.6919,7.6914,8.0003,10.9998,8.0003 M10.9998,7.0003c-3.866,0-7,3.133-7,7c0,0.25,0.015,0.496,0.04,0.738
                        c-1.194,0.48-2.04,1.645-2.04,3.012c0,1.794,1.455,3.25,3.25,3.25h12.4c2.403,0,4.35-1.948,4.35-4.35
                        c0-2.356-1.875-4.263-4.213-4.337C17.0318,9.2633,14.2838,7.0003,10.9998,7.0003L10.9998,7.0003z"/>
                </g>
            </g>
            </svg>
    </div>
  );
}
}
export default SunCloud;